import useAccountsList from './useAccountsList'

export default useAccountsList
